// src/components/auth/SocialButtons.tsx
import React from 'react';
import { Facebook } from 'lucide-react';
import { useLanguage } from '@/hooks/useLanguage';

interface SocialButtonsProps {
  onFacebookLogin: () => void;
  onGoogleLogin: () => void;
}

const SocialButtons: React.FC<SocialButtonsProps> = ({
  onFacebookLogin,
  onGoogleLogin
}) => {
  const { t } = useLanguage();
  
  return (
    <div className="grid grid-cols-2 gap-3">
      <button
        type="button"
        onClick={onFacebookLogin}
        className="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
        aria-label={t('social.facebook_login')}
      >
        <Facebook className="w-5 h-5 text-blue-600" />
        <span className="ml-2">{t('social.facebook')}</span>
      </button>
      <button
        type="button"
        onClick={onGoogleLogin}
        className="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
        aria-label={t('social.google_login')}
      >
        <svg className="w-5 h-5 text-red-500" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12.545 10.239v3.821h5.445c-.712 2.315-2.647 3.972-5.445 3.972a6.033 6.033 0 110-12.064c1.498 0 2.866.549 3.921 1.453l2.814-2.814A9.969 9.969 0 0012.545 2C7.021 2 2.543 6.477 2.543 12s4.478 10 10.002 10c8.396 0 10.249-7.85 9.426-11.748l-9.426-.013z"/>
        </svg>
        <span className="ml-2">{t('social.google')}</span>
      </button>
    </div>
  );
};

export default SocialButtons;